export default __webpack_public_path__ + "static/media/2.fa518d3d.png";